import { Outlet, useNavigate } from "react-router-dom";
import { getAuthToken } from "../shared/services/authentication";
import { useEffect } from "react";

interface ProtectedRouteProps {
  allowedRoles: string[];
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ allowedRoles }) => {
  const navigate = useNavigate();
  const token = getAuthToken();

  useEffect(() => {
    if (token === null) {
      navigate("/unauthorized", { replace: true });
    }
  }, [token, navigate]);
  
  if (token === null) {
    return null;
  }

  return <Outlet />;
};

export default ProtectedRoute;
